export const ApplicationTypes = {
  DEALS: "DEALS",
  STAND_ALONE_TRAVEL: "STAND_ALONE_TRAVEL",
  TRAVEL_ONLY: "TRAVEL_ONLY",
};
